import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import { siteManagement } from '../../../../redux/actions';
import { Link } from 'react-router';

const UserSearch = () => {
	const [fields, setFields] = useState({
		userId: '',
		userEmail: ''
	});
	const [searchBy, setSearchBy] = useState();
	const [searchResult, setSearchResult] = useState(null);
	const [sortBy, setSortBy] = useState('LAST_UPDATED_DESC');
	const dispatch = useDispatch();

	const getSortedRecords = records => {
		if (records) {
			const sortByField = sortBy.substring(0, sortBy.lastIndexOf('_'));
			const sortOrder = sortBy.substring(sortBy.lastIndexOf('_') + 1);
			const sortedRecords = [...records];
			switch (sortByField) {
				case 'USER_ID':
					sortedRecords.sort((a, b) => (sortOrder === 'ASC' ? a.userId.localeCompare(b.userId) : b.userId.localeCompare(a.userId)));
					break;
				case 'STATUS':
					sortedRecords.sort((a, b) => (sortOrder === 'ASC' ? a.approvalStatus.localeCompare(b.approvalStatus) : b.approvalStatus.localeCompare(a.approvalStatus)));
					break;
				case 'LAST_UPDATED':
					sortedRecords.sort((a, b) => {
						if (!a.updatedDate) {
							return 1;
						}
						if (!b.updatedDate) {
							return -1;
						}
						return sortOrder === 'ASC'
							? moment(a.updatedDate, 'MM/DD/YYYY').valueOf() - moment(b.updatedDate, 'MM/DD/YYYY').valueOf()
							: moment(b.updatedDate, 'MM/DD/YYYY').valueOf() - moment(a.updatedDate, 'MM/DD/YYYY').valueOf();
					});
					break;
			}
			return sortedRecords;
		}
	};

	useEffect(() => {
		if (searchResult && searchResult.records) {
			setSearchResult(searchResult => ({
				...searchResult,
				records: getSortedRecords(searchResult.records)
			}));
		}
	}, [sortBy]);

	const handleChange = e => {
		const { name: fieldName, value: fieldValue } = e.target;
		setFields(fields => ({
			...fields,
			[fieldName]: fieldValue
		}));
	};

	const handleSearch = e => {
		e.preventDefault();
		setSearchResult(null);
		const searchBy = e.target.name === 'user-email-search-form' ? 'userEmail' : 'userId';
		setSearchBy(searchBy);
		const queryParam = e.target.name === 'user-email-search-form' ? `&userEmail=${fields.userEmail.trim()}` : `&userId=${fields.userId.trim()}`;

		dispatch(
			siteManagement(undefined, `requestType=getUserDetails${queryParam}`, true, userDetailsResponse => {
				const searchResult = {
					searchBy,
					keyword: searchBy === 'userEmail' ? fields.userEmail.trim() : fields.userId.trim()
				};
				if (userDetailsResponse.responseObject) {
					const records = [];
					userDetailsResponse.responseObject.forEach(user => {
						if (user.accounts && user.accounts.length) {
							records.push(
								...(user.accounts || []).map(userAccount => ({ ...userAccount, firstName: user.firstName, lastName: user.lastName, email: user.emailAddress }))
							);
						} else {
							records.push({
								userId: user.userId,
								firstName: user.firstName,
								lastName: user.lastName,
								email: user.emailAddress,
								approvalStatus: ''
							});
						}
					});
					searchResult.records = getSortedRecords(records);
				} else {
					searchResult.records = [];
				}
				setSearchResult(searchResult);
			})
		);
	};

	const handleExport = e => {
		e.preventDefault();
		const queryParam = searchBy === 'userEmail' ? `&userEmail=${fields.userEmail.trim()}` : `&userId=${fields.userId.trim()}`;

		dispatch(
			siteManagement(undefined, `requestType=exportUserDetails${queryParam}`, true, userDetailsFileResponse => {
				if (userDetailsFileResponse.responseObject) {
					window.open(userDetailsFileResponse.responseObject);
				}
			})
		);
	};

	return (
		<div className="userSearch">
			<div className="push">
				<h1 className="pageTitle">USER SEARCH</h1>
			</div>
			<div className="push">
				<form className="userSearchForm" name="user-email-search-form" onSubmit={handleSearch}>
					<p>
						<label htmlFor="user-email">
							<b>User Email: </b>
						</label>
						<input type="text" id="user-email" name="userEmail" value={fields.userEmail} onChange={handleChange} />
					</p>
					<button disabled={!fields.userEmail.trim()}>Search</button>
				</form>
				<form className="userSearchForm" name="user-id-search-form" onSubmit={handleSearch}>
					<p>
						<label htmlFor="user-id">
							<b>User Id: </b>
						</label>
						<input type="text" id="user-id" name="userId" value={fields.userId} onChange={handleChange} />
					</p>
					<button disabled={!fields.userId.trim()}>Search</button>
				</form>
			</div>
			<div className="push">
				{searchResult && searchResult.records && searchResult.records.length === 0 && (
					<p className="text-center">
						No Records found for{' '}
						<strong>
							{searchResult.searchBy === 'userEmail' ? 'User Email' : 'User Id'}: {searchResult.keyword.toUpperCase()}
						</strong>
					</p>
				)}
				{searchResult && searchResult.records && searchResult.records.length > 0 && (
					<React.Fragment>
						<div className="userSearchResultsHeader flex justify-between items-center">
							<p className="my-0">
								<label htmlFor="sortBy">
									<b>Sort By:</b>{' '}
								</label>
								<select id="sortBy" value={sortBy} onChange={e => setSortBy(e.target.value)}>
									<option value="USER_ID_ASC">User Id</option>
									<option value="STATUS_ASC">Status</option>
									<option value="LAST_UPDATED_DESC">Last Updated</option>
								</select>
							</p>
							<a onClick={handleExport} className="withIcon withExportIcon noUnderline bold uppercase" href="">
								Export
							</a>
						</div>
						<div className="captionAboveTable">
							<strong>
								{searchResult.records.length} Records [{searchResult.searchBy === 'userEmail' ? 'User Email' : 'User Id'}: {searchResult.keyword.toUpperCase()}]
							</strong>
						</div>
						<div className="d-none d-sm-block">
							<table className="userDataTable dataTable small my-0 fullWidth">
								<thead>
									<tr>
										<th>User Id</th>
										<th>Email</th>
										<th>First Name</th>
										<th>Last Name</th>
										<th>Account</th>
										<th>Status</th>
										<th>Created Date</th>
										<th>Approved By</th>
										<th>Last Updated Date</th>
										<th>Last Updated By</th>
									</tr>
								</thead>
								<tbody>
									{searchResult.records.map(userAccount => (
										<tr key={`${userAccount.userId}-${userAccount.accountNumber || ''}`}>
											<td>{userAccount.userId}</td>
											<td>{userAccount.email}</td>
											<td>{userAccount.firstName}</td>
											<td>{userAccount.lastName}</td>
											<td>{userAccount.accountNumber}</td>
											<td>{userAccount.approvalStatus}</td>
											<td>{userAccount.createdDate}</td>
											<td>{userAccount.approvedBy}</td>
											<td>{userAccount.updatedDate}</td>
											<td>{userAccount.lastUpdatedBy}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						<div className="d-flex d-sm-none" style={{ flexDirection: 'column', rowGap: '1rem', marginTop: '1rem' }}>
							{searchResult.records.map(userAccount => (
								<div
									key={`${userAccount.userId}-${userAccount.accountNumber || ''}`}
									className="flex items-center"
									style={{ flexDirection: 'column', paddingBlock: '.75rem', border: '1px solid #a1a1a1', borderRadius: '.5rem' }}
								>
									<dl className="flex justify-between my-0 col-11">
										<dt>User Id</dt>
										<dd>{userAccount.userId}</dd>
									</dl>
									<hr className="col-11" style={{ marginBlock: '.5rem' }} />
									<dl className="flex justify-between my-0 col-11">
										<dt>Email</dt>
										<dd>{userAccount.email}</dd>
									</dl>
									<hr className="col-11" style={{ marginBlock: '.5rem' }} />
									<dl className="flex justify-between my-0 col-11">
										<dt>First Name</dt>
										<dd>{userAccount.firstName}</dd>
									</dl>
									<hr className="col-11" style={{ marginBlock: '.5rem' }} />
									<dl className="flex justify-between my-0 col-11">
										<dt>Last Name</dt>
										<dd>{userAccount.lastName}</dd>
									</dl>
									<hr className="col-11" style={{ marginBlock: '.5rem' }} />
									<dl className="flex justify-between my-0 col-11">
										<dt>Account</dt>
										<dd>{userAccount.accountNumber}</dd>
									</dl>
									<hr className="col-11" style={{ marginBlock: '.5rem' }} />
									<dl className="flex justify-between my-0 col-11">
										<dt>Status</dt>
										<dd>{userAccount.approvalStatus}</dd>
									</dl>
									<hr className="col-11" style={{ marginBlock: '.5rem' }} />
									<dl className="flex justify-between my-0 col-11">
										<dt>Created Date</dt>
										<dd>{userAccount.createdDate}</dd>
									</dl>
									<hr className="col-11" style={{ marginBlock: '.5rem' }} />
									<dl className="flex justify-between my-0 col-11">
										<dt>Approved By</dt>
										<dd>{userAccount.approvedBy}</dd>
									</dl>
									<hr className="col-11" style={{ marginBlock: '.5rem' }} />
									<dl className="flex justify-between my-0 col-11">
										<dt>Last Updated Date</dt>
										<dd>{userAccount.updatedDate}</dd>
									</dl>
									<hr className="col-11" style={{ marginBlock: '.5rem' }} />
									<dl className="flex justify-between my-0 col-11">
										<dt>Last Updated By</dt>
										<dd>{userAccount.lastUpdatedBy}</dd>
									</dl>
								</div>
							))}
						</div>
					</React.Fragment>
				)}
			</div>
			<p className="flex items-center justify-between">
				<Link to="/siteManagement">Back to Site Management</Link>
			</p>
		</div>
	);
};

export default UserSearch;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/UserSearch/index.jsx